/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var KubeImage;
    (function (KubeImage) {
        KubeImage["zeroData"] = "zeroData";
        KubeImage["zeroResults"] = "zeroResults";
        KubeImage["zeroWorkloads"] = "zeroWorkloads";
        KubeImage["resourceDeleted"] = "resourceDeleted";
        KubeImage["resourceAccessDenied"] = "resourceAccessDenied";
    })(KubeImage = exports.KubeImage || (exports.KubeImage = {}));
    /**
     * https://kubernetes.io/docs/concepts/workloads/pods/pod-lifecycle/#pod-phase
     **/
    var PodPhase;
    (function (PodPhase) {
        PodPhase["Pending"] = "Pending";
        PodPhase["Running"] = "Running";
        PodPhase["Succeeded"] = "Succeeded";
        PodPhase["Failed"] = "Failed";
        PodPhase["Unknown"] = "Unknown";
        PodPhase["Completed"] = "Completed";
        PodPhase["CrashLoopBackOff"] = "CrashLoopBackOff";
    })(PodPhase = exports.PodPhase || (exports.PodPhase = {}));
    var ResourceErrorType;
    (function (ResourceErrorType) {
        ResourceErrorType["Deleted"] = "Deleted";
        ResourceErrorType["AccessDenied"] = "AccessDenied";
        ResourceErrorType["None"] = "None";
        ResourceErrorType["NotInitialized"] = "NotInitialized";
    })(ResourceErrorType = exports.ResourceErrorType || (exports.ResourceErrorType = {}));
});
